import { render, staticRenderFns } from "./AddDealer.vue?vue&type=template&id=1dc0e498&"
import script from "./AddDealer.vue?vue&type=script&lang=js&"
export * from "./AddDealer.vue?vue&type=script&lang=js&"
import style0 from "./AddDealer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AddDealer.vue"
export default component.exports